import { render } from "./OnboardingCaregiver.vue?vue&type=template&id=52f0ce37&scoped=true"
import script from "./OnboardingCaregiver.vue?vue&type=script&lang=js"
export * from "./OnboardingCaregiver.vue?vue&type=script&lang=js"

import "./OnboardingCaregiver.vue?vue&type=style&index=0&id=52f0ce37&lang=css"
import "./OnboardingCaregiver.vue?vue&type=style&index=1&id=52f0ce37&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f0ce37"]])

export default __exports__